export const excludedPatterns = [
  'Viewer3D',
  'Viewer',
  'DICOM',
  'Embedded',
  'SandboxViewer'
]
